import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Settings, X } from 'lucide-react';
interface SettingsMenuProps {
  isOpen: boolean;
  onClose: () => void;
}
export function SettingsMenu({
  isOpen,
  onClose
}: SettingsMenuProps) {
  const [graphicsQuality, setGraphicsQuality] = useState(100);
  return <AnimatePresence data-id="element-621">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/50 z-[60]" data-id="element-622" />

          {/* Menu Panel */}
          <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.2
      }} className="fixed top-20 right-6 z-[70] bg-slate-800/95 backdrop-blur-xl rounded-xl border border-white/10 shadow-2xl p-6 min-w-[320px]" data-id="element-623">
            {/* Header */}
            <div className="flex items-center justify-between mb-6" data-id="element-624">
              <div className="flex items-center gap-2" data-id="element-625">
                <Settings className="w-5 h-5 text-white/70" data-id="element-626" />
                <h3 className="text-white font-medium" data-id="element-627">Settings</h3>
              </div>
              <button onClick={onClose} className="p-1 rounded-lg hover:bg-white/10 transition-colors" data-id="element-628">
                <X className="w-5 h-5 text-white/70" data-id="element-629" />
              </button>
            </div>

            {/* Graphics Resolution */}
            <div className="space-y-3" data-id="element-630">
              <label className="text-white/70 text-sm" data-id="element-631">
                Graphics Resolution
              </label>
              <div className="flex items-center gap-3" data-id="element-632">
                <input type="range" min="0" max="100" value={graphicsQuality} onChange={e => setGraphicsQuality(Number(e.target.value))} className="flex-1 h-2 bg-slate-700 rounded-lg appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-cyan-500" data-id="element-633" />
                <span className="text-cyan-500 font-medium text-sm w-12 text-right" data-id="element-634">
                  {graphicsQuality}%
                </span>
              </div>
              <div className="flex items-center justify-between text-xs text-white/50" data-id="element-635">
                <span data-id="element-636">Low</span>
                <span data-id="element-637">Cinematic</span>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}